import { render } from "./_tool-modal2.vue?vue&type=template&id=b00180d6"
import script from "./_tool-modal2.vue?vue&type=script&lang=js"
export * from "./_tool-modal2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__